export class Constants {
    public static dateFormat: 'YYYY-MM-DD';
    public static dateTimeFormat: 'YYYY-MM-DD HH:MM:SS';
    public static dateTimeFormatWOSS: 'yyyy-MM-dd hh:mm';
    public static cellMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    public static val_pattern_chars = "^[a-zA-Z ]*$";
    public static val_pattern_Numchars = "^[0-9a-zA-Z]*$";
    public static val_pattern_number = "^[+()0-9]*$";
    public static val_pattern_username = "^(?=.*@).+";
    public static val_pattern_numberDecimal = "^[0-9.]*$";
    public static val_pattern_2decimal = '^\\d+\\.\\d{2}$';
    public static val_pattern_website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
}